import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import analyticsService from "../../redux/services/analytics.service";

const MonthlyEarnings = ({ from, to, storeId }) => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const res = await analyticsService.monthlyPlatformEarning({ from, to, storeId });
        const d = res.data?.data ?? res.data;
        if (!alive) return;
        setRows(Array.isArray(d?.rows) ? d.rows : Array.isArray(d) ? d : []);
      } catch {
        if (!alive) return;
        setRows([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [from, to, storeId]);

  const categories = useMemo(() => rows.map((r) => r.month ?? r.label ?? r.key ?? "—"), [rows]);

  const options = useMemo(
    () => ({
      chart: { type: "line" },
      xaxis: { categories },
      title: { text: "Monthly platform earning", align: "left" },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth" },
    }),
    [categories]
  );

  const series = useMemo(() => {
    const values = rows.map((r) => Number(r.platformEarning ?? r.value ?? 0) || 0);
    return [{ name: "Platform earning (₹)", data: values }];
  }, [rows]);

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        <div className="small text-muted mb-2">{loading ? "Loading…" : "Monthly platform earning"}</div>
        <Chart options={options} series={series} type="line" height={300} />
      </Card.Body>
    </Card>
  );
};

export default MonthlyEarnings;
